import { Model } from 'modules/core/lib/mobx-rest'

export interface INineGridBoxSetup {
  id: number
  owner_id: number
  access_ids: number[]
  x_axis_ids: number[]
  y_axis_ids: number[]
  x_axis_name: string
  y_axis_name: string
}

class NineGridBoxSetup extends Model<INineGridBoxSetup> {
  static urlRoot() {
    return '/competencies/nine_grid_configurations'
  }
}

export default NineGridBoxSetup
